import { Language } from "interfaces/locale";
import { RouteKeys, ROUTES } from "./routes";

export const langs: Record<Language, Language> = { pt: "pt", en: "en", es: "es" };

const toSegments = (pathname: string) => {
  return pathname
    .split("?")[0]
    .split("#")[0]
    .split("/")
    .filter(Boolean)
    .map(decodeURIComponent);
};

export const translateSegmentsAuto = (
  pathname: string,
  from: Language,
  to: Language,
): string => {
  const segments = toSegments(pathname);
  const entries = ROUTES[from] as Record<RouteKeys, string>;
  const urlSegments: Array<RouteKeys | undefined> = segments.map((seg) => {
    const match = (Object.entries(entries) as Array<[RouteKeys, string]>).find(
      ([, value]) => value === `/${seg}`,
    );
    return match?.[0];
  });

  let newUrl = to === langs.pt ? "" : `/${to}`;

  urlSegments.forEach((seg) => {
    if (seg) {
      newUrl += `${(ROUTES[to] as Record<RouteKeys, string>)[seg]}`;
    }
    return "";
  });

  if (!newUrl) {
    return "/";
  }

  return newUrl;
};
